import { api } from './api';

/**
 * Lite shape returned by the list endpoint — drops the heavy snapshot blob.
 */
export interface WorkbookLite {
  id: string;
  workspaceId: string;
  name: string;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

/**
 * Full workbook including the opaque Univer IWorkbookData snapshot.
 * The shape is owned by Univer; the backend stores it verbatim.
 */
export interface Workbook extends WorkbookLite {
  snapshot: Record<string, unknown>;
}

export interface SaveSnapshotResult {
  updatedAt: string;
}

export const workbooksApi = {
  async list(workspaceId: string): Promise<WorkbookLite[]> {
    const r = await api.get<WorkbookLite[]>(`/api/workspaces/${workspaceId}/workbooks`);
    return r.data;
  },
  async create(workspaceId: string, name?: string): Promise<Workbook> {
    const r = await api.post<Workbook>(
      `/api/workspaces/${workspaceId}/workbooks`,
      name ? { name } : {},
    );
    return r.data;
  },
  async get(workbookId: string): Promise<Workbook> {
    const r = await api.get<Workbook>(`/api/workbooks/${workbookId}`);
    return r.data;
  },
  async rename(workbookId: string, name: string): Promise<WorkbookLite> {
    const r = await api.patch<WorkbookLite>(`/api/workbooks/${workbookId}`, { name });
    return r.data;
  },
  async saveSnapshot(workbookId: string, snapshot: Record<string, unknown>): Promise<SaveSnapshotResult> {
    const r = await api.put<SaveSnapshotResult>(`/api/workbooks/${workbookId}/snapshot`, { snapshot });
    return r.data;
  },
  async delete(workbookId: string): Promise<void> {
    await api.delete(`/api/workbooks/${workbookId}`);
  },
};
